import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import myCar from './views/my-car'
import addMyCar from './views/add-my-car'

export default [
  {
    path: RoutePathConstants.MY_CAR,
    name: 'myCar',
    component: myCar
  },
  {
    path: RoutePathConstants.ADD_MY_CAR,
    name: 'addMyCar',
    component: addMyCar
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-car/routers.js